import * as _ from "lodash-es";
import { getGradeLabel } from "@/features/schools/services";
import { getFirstParent, getSecondParent } from "@/features/student/services";
import { addressToString } from "@/utils";

const PROFILES_COUNT_TO_STORE = 5;
const LAST_VIEWED_PROFILES_KEY = "dashboard:lastViewedProfiles";

const extractAvailableAddressesFromProfile = (profile) => {
  const addresses = [];
  const appendAddress = (address, description) => {
    if (!address || !address.id || !addressToString(address)) {
      return;
    }
    addresses.push({
      address: address,
      description: description,
    });
  };

  // Profile
  const studentName = `${profile.first_name} ${profile.last_name}`;
  const studentDescription = `${studentName}, ${getGradeLabel(profile.entry_grade)} ${
    profile.entry_year
  }`;
  appendAddress(
    profile.residential_address,
    `${studentDescription}, Residential Address`,
  );
  appendAddress(profile.mailing_address, `${studentDescription}, Mailing Address`);

  // Parent 1
  const firstParent = getFirstParent(profile);
  appendAddress(
    firstParent.residential_address,
    `[${studentName}] Parent 1, ${firstParent.first_name} ${firstParent.last_name}, Residential Address`,
  );
  appendAddress(
    firstParent.mailing_address,
    `[${studentName}] Parent 1, ${firstParent.first_name} ${firstParent.last_name}, Mailing Address`,
  );

  // Parent 2
  const secondParent = getSecondParent(profile);
  if (secondParent) {
    appendAddress(
      secondParent.residential_address,
      `[${studentName}] Parent 2, ${secondParent.first_name} ${secondParent.last_name}, Residential Address`,
    );
    appendAddress(
      secondParent.mailing_address,
      `[${studentName}] Parent 2, ${secondParent.first_name} ${secondParent.last_name}, Mailing Address`,
    );
  }

  return addresses;
};

export default {
  namespaced: true,
  state: {
    lastViewedProfiles: JSON.parse(
      localStorage.getItem(LAST_VIEWED_PROFILES_KEY) || "[]",
    ),
    recordsEditing: {},
    profilesForAddresses: {},
  },
  getters: {
    getOtherUsersEdit(state, getters, rootState) {
      return (recordId) =>
        (state.recordsEditing[recordId] || []).filter(
          (id) => id !== (rootState.user && rootState.user.id),
        );
    },
    availableAddresses(state) {
      return Object.values(state.profilesForAddresses).flatMap((profile) =>
        extractAvailableAddressesFromProfile(profile),
      );
    },
    availableNonUserParents(state) {
      return Object.values(state.profilesForAddresses)
        .filter(
          (profile) =>
            profile.non_user_parent &&
            profile.non_user_parent.id &&
            profile.non_user_parent.first_name &&
            profile.non_user_parent.last_name,
        )
        .map((profile) => ({
          ...profile.non_user_parent,
          student_profile_id: profile.id,
          student_description: `${profile.first_name} ${
            profile.last_name
          }, ${getGradeLabel(profile.entry_grade)} ${profile.entry_year}`,
        }));
    },
  },
  mutations: {
    setRecordEditing(state, { record_id, users_list }) {
      state.recordsEditing = {
        ...state.recordsEditing,
        [record_id]: users_list,
      };
    },
    viewProfile: function (state, profile) {
      state.lastViewedProfiles = [
        _.pick(profile, [
          "id",
          "first_name",
          "last_name",
          "dob",
          "entry_year",
          "entry_grade",
          "application_status",
        ]),
        ...state.lastViewedProfiles.filter((p) => p.id !== profile.id),
      ].slice(0, PROFILES_COUNT_TO_STORE);
      localStorage.setItem(
        LAST_VIEWED_PROFILES_KEY,
        JSON.stringify(state.lastViewedProfiles),
      );
    },
    clearProfilesForAddresses: function (state) {
      state.profilesForAddresses = {};
    },
    addProfileForAddresses: function (state, profile) {
      state.profilesForAddresses = {
        ...state.profilesForAddresses,
        [profile.id]: profile,
      };
    },
  },
};
